var $ = require('jquery');
var lottie = require('lottie-web');
var anime = require('animejs');

module.exports = {
	init: function () {
        console.log('Running animations');

        anime({
            targets: '.block.featured-animation .content',
            opacity: [0,1],
            duration: 2000,
            delay: 2000
        });

        // Site fade ins

        // Intro blocks
        var introBlock = document.querySelectorAll('.block.intro .col');
        $(document).ready( function() {
            for (var i = 0; i < introBlock.length; i++) {
                var introEl = introBlock[i];
                new Waypoint({
                    element: introEl,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Background color swipe - Hero Style 3
        var heroStyle3 = document.querySelectorAll('.block.hero');
        $(document).ready( function() {
            for (var i = 0; i < heroStyle3.length; i++) {
                var heroBG = heroStyle3[i];
                new Waypoint({
                    element: heroBG,
                    handler: function() {
                        this.element.classList.add('swipe');
                    },
                    offset: '85%'
                });
            }
        });

        // Hero blocks
        var heroBlock = document.querySelectorAll('.block.hero:not(.style-1) .wrapper');
        $(document).ready( function() {
            for (var i = 0; i < heroBlock.length; i++) {
                var blockEl = heroBlock[i];
                new Waypoint({
                    element: blockEl,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            delay: 600,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Hero blocks - Style 1
        var heroBlock1 = document.querySelectorAll('.block.hero.style-1 .wrapper');
        $(document).ready( function() {
            for (var i = 0; i < heroBlock1.length; i++) {
                var blockEl1 = heroBlock1[i];
                new Waypoint({
                    element: blockEl1,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Listing block - Cards
        function fadeListingBlocks() {
            var listingBlockCard = document.querySelectorAll('.layout.listing .block-single-card');
            $(document).ready( function() {
                for (var i = 0; i < listingBlockCard.length; i++) {
                    var cardEl = listingBlockCard[i];
                    var cardOffset = i * 100;
                    new Waypoint({
                        element: cardEl,
                        handler: function() {
                            anime({
                                targets: this.element,
                                opacity: 1,
                                duration: 400,
                                easing: 'cubicBezier(.5, .05, .1, .3)'
                            });
                        },
                        offset: '85%'
                    });
                }
            });
        }
        fadeListingBlocks();

        // Load More - Fading in new posts added when clicking the load more button
        $(document).click('.facetwp-load-more', function() {
            // console.log('Clicked on load more button');
            setTimeout( function() {
                // Listing block - Cards
                fadeListingBlocks();
            }, 1000);
        });

        (function($) {
            $(document).on('facetwp-refresh', function() {
                // console.log('facetwp-refresh evt');
            });
            $(document).on('facetwp-loaded', function() {
                // console.log('facetwp-loaded evt');
                fadeListingBlocks();
            });
        })(jQuery);

        // Cards Block - Intro
        var cardBlockIntro2 = document.querySelectorAll('.block.cards .intro');
        $(document).ready( function() {
            for (var i = 0; i < cardBlockIntro2.length; i++) {
                var cardEl2 = cardBlockIntro2[i];
                new Waypoint({
                    element: cardEl2,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Cards Block - Cards
        var cardBlock2 = document.querySelectorAll('.block.cards .block-single-card');
        $(document).ready( function() {
            for (var i = 0; i < cardBlock2.length; i++) {
                var cardEl2 = cardBlock2[i];
                new Waypoint({
                    element: cardEl2,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Background color swipe - Cards Style 1
        var cardsSwipe = document.querySelectorAll('.block.cards.style-1');
        $(document).ready( function() {
            for (var i = 0; i < cardsSwipe.length; i++) {
                var cardsBG = cardsSwipe[i];
                // Change inline background color to a linear gradient
                var styleInline = cardsBG.style;
                if ( styleInline['backgroundColor'] !== '' ) {
                    // Add new background style
                    var newBG = 'background-color: ' + styleInline['backgroundColor'] + '; background-image: linear-gradient(to left, ' + styleInline['backgroundColor'] + ' 50%, #ffffff 50%);';
                    cardsBG.setAttribute('style', newBG);
                    new Waypoint({
                        element: cardsBG,
                        handler: function() {
                            this.element.classList.add('swipe');
                        },
                        offset: '85%'
                    });

                    var cardBlockIntro1 = cardsBG.querySelectorAll('.intro');
                    for (var i = 0; i < cardBlockIntro1.length; i++) {
                        var cardEl1 = cardBlockIntro1[i];
                        new Waypoint({
                            element: cardEl1,
                            handler: function() {
                                anime({
                                    targets: this.element,
                                    opacity: 1,
                                    duration: 400,
                                    delay: 600,
                                    easing: 'cubicBezier(.5, .05, .1, .3)'
                                });
                            },
                            offset: '85%'
                        });
                    }

                    var cardBlock1 = cardsBG.querySelectorAll('.block-single-card');
                    for (var i = 0; i < cardBlock1.length; i++) {
                        var cardEl1 = cardBlock1[i];
                        new Waypoint({
                            element: cardEl1,
                            handler: function() {
                                anime({
                                    targets: this.element,
                                    opacity: 1,
                                    duration: 400,
                                    delay: 600,
                                    easing: 'cubicBezier(.5, .05, .1, .3)'
                                });
                            },
                            offset: '85%'
                        });
                    }

                } 
            }
        });      

        // Background color swipe - Testimonials
        var testimonialSwipe = document.querySelectorAll('.layout.testimonial.slider');
        $(document).ready( function() {
            for (var i = 0; i < testimonialSwipe.length; i++) {
                var testimonialBG = testimonialSwipe[i];
                new Waypoint({
                    element: testimonialBG,
                    handler: function() {
                        this.element.classList.add('swipe');
                    },
                    offset: '85%'
                });
            }
        });

        // Testimonials block
        var testimonialsBlock = document.querySelectorAll('.layout.testimonial .wrapper');
        $(document).ready( function() {
            for (var i = 0; i < testimonialsBlock.length; i++) {
                var testimonialsEl = testimonialsBlock[i];
                new Waypoint({
                    element: testimonialsEl,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            delay: 600,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });

        // Logos block
        var logosBlock = document.querySelectorAll('.layout.logos');
        $(document).ready( function() {
            for (var i = 0; i < logosBlock.length; i++) {
                var logosEl = logosBlock[i];
                new Waypoint({
                    element: logosEl,
                    handler: function() {
                        anime({
                            targets: this.element,
                            opacity: 1,
                            duration: 400,
                            easing: 'cubicBezier(.5, .05, .1, .3)'
                        });
                    },
                    offset: '85%'
                });
            }
        });
        

        // Animations below are used for static front end development

        // lottie.loadAnimation({
        //     container: document.getElementById('lottie-blog'), // the dom element that will contain the animation
        //     renderer: 'svg',
        //     loop: false,
        //     autoplay: true,
        //     delay: 300,
        //     path: '/app/themes/mightily/dist/assets/lottie/Blogdata.json' // the path to the animation json
        //     // path: '/assets/lottie/Blogdata.json' // the path to the animation json
        // });

        // lottie.loadAnimation({
        //     container: document.getElementById('lottie-services'), // the dom element that will contain the animation
        //     renderer: 'svg',
        //     loop: false,
        //     autoplay: true,
        //     delay: 300,
        //     path: '/app/themes/mightily/dist/assets/lottie/Servicesdata.json' // the path to the animation json
        //     // path: '/assets/lottie/Servicesdata.json' // the path to the animation json
        // });

        // lottie.loadAnimation({
        //     container: document.getElementById('lottie-home'), // the dom element that will contain the animation
        //     renderer: 'svg',
        //     loop: false,
        //     autoplay: true,
        //     delay: 300,
        //     // path: '/app/themes/mightily/dist/assets/lottie/Homedata.json' // the path to the animation json
        //     path: '/assets/lottie/Homedata.json' // the path to the animation json
        // });

    }
}